import classes from "./Header.module.css";
import cart from "../images/cart.webp";
import { CartContext } from "../../CartContext";
import { useContext } from "react";
import Flip from "react-reveal/Flip";

const HeaderCartButton = (props) => {
  const carts = useContext(CartContext);

  const productCount = carts.items.reduce(
    (acc, item) => acc + item.quantity,
    0
  );

  return (
    <Flip left>
      <button onClick={props.showCart} className={classes.btns}>
        <i class="fa-solid fa-cart-shopping"></i>
        <span>{productCount}</span>
      </button>
    </Flip>
  );
};

export default HeaderCartButton;
